import getSubmissionsAppRoute from 'forms-utils-lib/urls/submissions/getSubmissionsAppRoute';
const getSubmissionsUrl = (formGuid, tab) => getSubmissionsAppRoute(formGuid, tab);
export default getSubmissionsUrl;